import React from 'react';
import _ from 'lodash';
import { Grid, Input } from 'semantic-ui-react';
import styles from './FormPreview.module.css';

export default function FormikEnabledDateTimeComponent({ attributeObj, formik, isCommonFieldDisabled, print }) {
  let dateTimeValue = _.get(formik.values, attributeObj.id);
  dateTimeValue = dateTimeValue || { date: '', time: '' };
  const { date, time } = dateTimeValue;
  const onDateChange = (e) => {
    const newDateTimeValue = { ...dateTimeValue, date: e.target.value };
    formik.setFieldValue(attributeObj.id, newDateTimeValue, false);
  };
  const onTimeChange = (e) => {
    const newDateTimeValue = { ...dateTimeValue, time: e.target.value };
    formik.setFieldValue(attributeObj.id, newDateTimeValue, false);
  };
  const onInputBlur = () => {
    formik.setFieldTouched(attributeObj.id, true, false);
  };
  const err = _.get(formik.errors, attributeObj.id);
  return (
    <div className="print-container">
      <label style={{ margin: '12px 24px' }}>
        {attributeObj.label}

        {attributeObj?.taskId && attributeObj?.isRequired && <span className="mandatory-resolve-field">*</span>}
        {!attributeObj?.taskId ? (
          attributeObj?.isRequiredOnCreation ? (
            <span className="mandatory-field">*</span>
          ) : attributeObj?.isRequired ? (
            <span className="mandatory-resolve-field">*</span>
          ) : (
            ''
          )
        ) : (
          ''
        )}
      </label>
      <div className={`${styles.inputbox} input-box-holder`}>
        {!print && (
          <>
            <Grid columns={2} doubling>
              <Grid.Column>
                <Input
                  type="date"
                  onBlur={onInputBlur}
                  onChange={onDateChange}
                  value={date}
                  disabled={attributeObj.disabled || isCommonFieldDisabled}
                />
              </Grid.Column>
              <Grid.Column>
                <Input
                  type="time"
                  onBlur={onInputBlur}
                  onChange={onTimeChange}
                  value={time}
                  disabled={attributeObj.disabled || isCommonFieldDisabled}
                />
              </Grid.Column>
            </Grid>
            {err && <div className="errorText">* {err}</div>}
          </>
        )}
        {print && (
          <>
            <div className="print-content-text">{`${date} ${time}`}</div>
          </>
        )}
      </div>
    </div>
  );
}
